<template>
  <div class="barcode">
    <div
      class="text-center"
      v-if="$store.state.user.sections['scan_trade_ins']"
    >
      <div>
        <img class="barcode-img" src="@/assets/img/scan.png" />
      </div>

      <div class="bardcode-form">
        <form @submit.prevent="search">
          <fg-input
            ref="myInput"
            :type="`text`"
            :placeholder="`Введите штрих-код сейф-пакета`"
            :labelKey="`input_limit`"
            v-model="code"
          ></fg-input>

          <button class="btn btn-info w-100">Продолжить</button>
        </form>
      </div>
    </div>
    <h4 v-else>{{ "no_acccess" | setText("НЕТ ДОСТУПА") }}</h4>
  </div>
</template>
<script>
export default {
  watch: {},
  name: "products",
  mounted() {
    try {
      setTimeout(() => {
        this.$refs.myInput.focus();
      }, 10);
    } catch (error) {}
  },
  methods: {
    getProjectInfo(id) {
      let query = Object.assign({}, this.$route.query);
      if (query["item_trade_in_info"] == id) {
        return false;
      }
      if (query["item_trade_in_info"]) {
        delete query["item_trade_in_info"];
      }
      query["item_trade_in_info"] = id;
      setTimeout(() => {
        this.$router.replace({ query: query });
      }, 20);
    },
    search() {
      this.$http
        .post(
          "trade_ins/scan",
          { code: this.code },
          {
            code: this.code,
          }
        )
        .then((res) => {
          this.getProjectInfo(res.data.data.id);
        })
        .catch((err) => {
          this.$notify({
            title: "Ошибка",
            message: "Штрих-код не найден",
            type: "danger",
          });
        })
        .finally(() => {
          this.code = "";
        });
    },
  },
  data() {
    return {
      code: null,
    };
  },
};
</script>


<style lang="scss">
.barcode {
  padding: 30px;
  margin: auto;
  border-radius: 20px;
  text-align: center;
  background: #fff;
  width: 400px;
  max-width: 100%;
  &-img {
    width: 90px;
    margin-bottom: 30px;
  }
}
</style>